export default __webpack_public_path__ + "static/media/moveFolder.4a338246.png";